export default axios => ({
    get() {
        return axios.get(`/service-menu`)
    }
})
